import createOnClickTracker from '../utils/tracker';

export default function AOCtaButton() {
  const initiate = () => {
    const $cta = $('.js-aa-clp-cta-button__button');
    $cta.click(createOnClickTracker('CTA Button'));
  };

  return { initiate };
}
